import * as React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { useParams, useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import {
    Grid,
    Paper,
    FormControl, InputLabel, Select, MenuItem, TextField,
    Divider
} from '@material-ui/core';

import { useServiceClient, usePreferences } from '../../contexts';
import { CatalogEntry } from '../../../lib/serviceClient';

const styles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(1)
    },
    formControl: {
        minWidth: 150,
        paddingBottom: theme.spacing(1)
    },
    textarea: {
        resize: "vertical"
    },
    divider: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }
}));

export function LayoutDataAccessComponent() {
    const classes = styles();

    const { layoutKey } = useParams<{ layoutKey?: string }>()
    const history = useHistory();

    const serviceClient = useServiceClient();
    const [ preferences, setPreferences ] = usePreferences();

    React.useEffect(() => {
        if (!layoutKey && !!preferences.layoutId) {
            history.replace(`/data-access/layout/${preferences.layoutId}`);
        }
    }, [ layoutKey, preferences ]);
    React.useEffect(() => {
        if (!layoutKey)
            return;

        setPreferences(prev => ({
            ...prev,
            layoutId: layoutKey
        }));
    }, [ layoutKey ]);

    const [ availableLayouts, setAvailableLayouts ] = React.useState<CatalogEntry[]>([]);
    React.useEffect(() => {(async () => {
        const layouts = await serviceClient.getCatalogLayouts();

        setAvailableLayouts(layouts);
    })()}, [ serviceClient ]);

    const [ layout, setLayout ] = React.useState<unknown>();
    React.useEffect(() => {(async () => {
        if (!layoutKey)
            return;

        const catalogLayout = availableLayouts.find(e => e.key === layoutKey);
        if (!catalogLayout)
            return;

        const layout = await serviceClient.getLayout(catalogLayout.name);

        setLayout(layout);
    })()}, [ serviceClient, layoutKey, availableLayouts ]);

    const onSelectedLayoutChange = (e: React.ChangeEvent<{ value: string }>) => {
        history.push(`/data-access/layout/${e.target.value}`);
    }

    return (
        <div className={classes.root}>
            <FormControl className={classes.formControl}>
                <InputLabel id="layout-name-label">Layout Name</InputLabel>
                <Select labelId="layout-name-label" id="layout-name-select" value={layoutKey || ''} onChange={onSelectedLayoutChange}>
                    {availableLayouts.map(layout => <MenuItem value={layout.key}>{layout.displayName}</MenuItem>)}
                </Select>
            </FormControl>

            {layout && <TextField
                inputProps={{ className: classes.textarea }}
                disabled
                fullWidth
                variant="outlined"
                label="Raw Layout"
                InputLabelProps={{ shrink: true }}
                margin="dense"
                multiline
                rows={20}
                value={JSON.stringify(layout, null, 2)}
            />}
        </div>
    );
}